import { computed as u, ref as y, onMounted as w, createBlock as h, openBlock as o, unref as S, normalizeClass as n, withCtx as k, createElementBlock as d, createCommentVNode as s, createElementVNode as l, normalizeStyle as z, createVNode as v, toDisplayString as c } from "vue";
import M from "../../atoms/anchor-element/anchor-element.vue.js";
import j from "../../atoms/tag/tag.vue.js";
import x from "../../atoms/image-element/image-element.vue.js";
import { screenProp as B, isScreenSmall as L } from "../../utils/utilsScreen.js";
import { themeProp as W } from "../../composables/useTheme.js";
import { useTracking as p } from "../../composables/useTracking.js";
/* empty css               */
import O from "../../utils/validators/aspect-ratio.js";
const $ = ["src", "alt"], C = { class: "ds-blog-card__content" }, E = {
  key: 0,
  class: "ds-blog-card__eyebrow ds-color-green ds-text-small ds-text-transform-uppercase ds-margin-bottom-8 ds-font-weight-bold",
  "data-j-eyebrow": ""
}, N = { class: "ds-blog-card__footer ds-padding-top-12" }, P = {
  class: "ds-text-small ds-color-grey-1900",
  "data-j-subtitle": ""
}, G = /* @__PURE__ */ Object.assign({
  name: "DsCardBlog"
}, {
  __name: "card-blog",
  props: {
    ...W,
    ...B,
    link: {
      type: Object,
      required: !0,
      validator: (e) => ["title", "url", "openInNewWindow", "nuxt"].every((r) => r in e)
    },
    /* Use if the image has only one set of sizes */
    image: {
      type: Object,
      default: null
    },
    /*
     * Use to render DsImageElement with different aspect ratios for screen sizes
     * Recommended for usages when horizontalMinMedium is set
     */
    imageWithSizes: {
      type: Object,
      default: null
    },
    /* @deprecated - Eyebrow prop is going to be deprecated - use tag for instead of eyebrow */
    eyebrow: {
      type: String,
      default: ""
    },
    tag: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      required: !0
    },
    title: {
      type: String,
      required: !0
    },
    contained: {
      type: Boolean,
      default: !1
    },
    /* Used to show a big card with more spacing */
    withSpacingLarge: {
      type: Boolean,
      default: !1
    },
    /* Image and the card content in one row within media('medium') */
    horizontalMinMedium: {
      type: Boolean,
      default: !1
    },
    aspectRatio: {
      type: String,
      default: null,
      validator: (e) => O(e)
    },
    /*
     * Use this prop to have default grey placeholder on image
     * But if the usecase requires other changes, use emitted event 'image-load-failed'
     */
    showPlaceholderOnImageError: {
      type: Boolean,
      default: !1
    },
    lazyUrlEndpoint: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const { trackingDataProvided: r } = p(), a = e, b = u(() => {
      var t, i, g;
      return a.horizontalMinMedium && !L(a.screen) ? `${(g = (i = (t = a.imageWithSizes) == null ? void 0 : t[a.screen]) == null ? void 0 : i.dimensions) == null ? void 0 : g.width}px` : "";
    }), m = y(null), f = u(() => a.link.url || m.value);
    return w(async () => {
      if (a.link.lazyUrl)
        try {
          const i = await (await fetch(a.link.lazyUrl)).json();
          m.value = i == null ? void 0 : i.link;
        } catch (t) {
          console.error(t);
        }
    }), (t, i) => (o(), h(M, {
      class: n(["ds-blog-card", [
        `ds-blog-card--${t.theme}`,
        { "ds-blog-card--contained": e.contained },
        { "ds-blog-card--horizontal": e.horizontalMinMedium }
      ]]),
      "tracking-data": { "component-name": "CardBlog", text: e.title, ...S(r) },
      url: f.value,
      "open-in-new-window": e.link.openInNewWindow,
      nuxt: e.link.nuxt,
      "aria-label": e.link.title,
      "data-j-link": "",
      "data-allow-mismatch": ""
    }, {
      default: k(() => [
        e.imageWithSizes ? (o(), d("div", {
          key: 0,
          style: z({ width: b.value }),
          class: n({
            "ds-margin-bottom-24": !e.withSpacingLarge,
            "ds-margin-bottom-48": e.withSpacingLarge,
            "ds-md-margin-bottom-0": e.horizontalMinMedium
          })
        }, [
          v(x, {
            image: e.imageWithSizes,
            "aspect-ratio": e.aspectRatio,
            screen: t.screen,
            class: "ds-blog-card__image",
            "show-placeholder-on-error": e.showPlaceholderOnImageError
          }, null, 8, ["image", "aspect-ratio", "screen", "show-placeholder-on-error"])
        ], 6)) : e.image ? (o(), d("div", {
          key: 1,
          class: n(["ds-blog-card__image", {
            "ds-margin-bottom-24": !e.withSpacingLarge,
            "ds-margin-bottom-48": e.withSpacingLarge,
            "ds-md-margin-bottom-0": e.horizontalMinMedium
          }])
        }, [
          l("img", {
            src: e.image.src,
            alt: e.image.name,
            "data-j-image": ""
          }, null, 8, $)
        ], 2)) : s("", !0),
        l("div", C, [
          e.eyebrow ? (o(), d("p", E, c(e.eyebrow), 1)) : s("", !0),
          e.tag ? (o(), h(j, {
            key: 1,
            label: e.tag,
            color: "green",
            class: n({ "ds-margin-bottom-12": !e.withSpacingLarge, "ds-margin-bottom-24": e.withSpacingLarge })
          }, null, 8, ["label", "class"])) : s("", !0),
          l("div", {
            class: n(["ds-blog-card__body", `ds-blog-card__body--${t.theme}`])
          }, [
            l("h4", {
              class: n({ "ds-heading-xsmall": !e.withSpacingLarge, "ds-heading": e.withSpacingLarge }),
              "data-j-title": ""
            }, c(e.title), 3)
          ], 2),
          l("div", N, [
            l("p", P, c(e.subtitle), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["class", "tracking-data", "url", "open-in-new-window", "nuxt", "aria-label"]));
  }
});
export {
  G as default
};
